import { FolderDto, GalleryDto } from '@nusign/picflow-backend-types';
import { FolderAccessLevel, GalleryAccessLevel } from './access-level';

export const calcGalleryPermissions = (
  gallery: GalleryDto,
  accessLevel?: GalleryAccessLevel
): GalleryDto['permissions'] => {
  if (!gallery) return;
  if (gallery.permissions) {
    if (gallery.permissions.can_review && !gallery.permissions.can_review_if_authenticated) {
      gallery.permissions.can_review_if_authenticated = true;
    }
    return gallery.permissions;
  }

  const fallbackPermissions: GalleryDto['permissions'] = {
    can_review: accessLevel === 'edit' || accessLevel === 'review',
    can_review_if_authenticated: accessLevel === 'edit' || accessLevel === 'review',
    can_edit: accessLevel === 'edit',
  };

  return fallbackPermissions;
};

export const calcFolderPermissions = (folder: FolderDto, accessLevel: FolderAccessLevel): FolderDto['permissions'] => {
  if (!folder) return;
  if (folder.permissions) {
    if (folder.permissions.can_review && !folder.permissions.can_review_if_authenticated) {
      folder.permissions.can_review_if_authenticated = true;
    }
    return folder.permissions;
  }

  const fallbackPermissions: FolderDto['permissions'] = {
    can_review: accessLevel === 'edit' || accessLevel === 'review',
    can_review_if_authenticated: accessLevel === 'edit' || accessLevel === 'review',
    can_edit: accessLevel === 'edit',
  };

  return fallbackPermissions;
};
